import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { GenderType } from '../../../../../core/domain/data';

@JsonConverter
export class GenderTypeAdapter implements JsonCustomConvert<GenderType | undefined> {
    serialize(type: GenderType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): GenderType | undefined {
        switch (type) {
            case 'E':
                return GenderType.CHOOSE;
            case '':
                return GenderType.CHOOSE;
            case 'M':
                return GenderType.WOMAN;
            default:
                return GenderType.MAN;
        }
    }
}
